"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalSearchResults = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const clsx_1 = __importDefault(require("clsx"));
const react_2 = require("react");
const react_i18next_1 = require("react-i18next");
const breakpoints_1 = require("../breakpoints");
const container_1 = require("./container");
const result_item_1 = require("./result-item");
const UniversalSearchResults = ({ data, userType }) => {
    const { orders, skus, asns, rmas } = data;
    const [filter, setFilter] = (0, react_2.useState)("all");
    const isMasonhubUser = (t) => t === "MASONHUB_ADMIN" || t === "SUPER_USER";
    const isVisible = (type) => filter === "all" || filter === type;
    const total = orders.length + skus.length + asns.length + rmas.length;
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: UniversalSearchResultsStyles }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "bg-white" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "universal-search-filter-tabs" }, { children: ["all", "skus", "asns", "orders", "rmas"].map(t => {
                        const count = t === "all" ? total
                            : t === "skus" ? skus.length
                                : t === "asns" ? asns.length
                                    : t === "orders" ? orders.length
                                        : rmas.length;
                        return ((0, jsx_runtime_1.jsxs)("button", Object.assign({ className: (0, clsx_1.default)("universal-search-filter-tab", { active: filter === t }), onClick: () => setFilter(t) }, { children: [(0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { i18nKey: `common:${t}` }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "tab-count" }, { children: count }))] }), t));
                    }) })), isVisible("skus") && ((0, jsx_runtime_1.jsx)(UniversalSearchResultsType, Object.assign({ typeKey: "skus", count: skus.length, dotColor: "#378ADD" }, { children: skus.length > 0 ? ((0, jsx_runtime_1.jsx)("ul", { children: skus.map(sku => ((0, jsx_runtime_1.jsx)(result_item_1.UniversalSearchResultsItem, Object.assign({}, sku, { isAccountLogoVisible: isMasonhubUser(userType) }), sku.id))) })) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "universal-search-empty" }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { i18nKey: "common:noSkusFound" }) }))) }))), isVisible("asns") && ((0, jsx_runtime_1.jsx)(UniversalSearchResultsType, Object.assign({ typeKey: "asns", count: asns.length, dotColor: "#639922" }, { children: asns.length > 0 ? ((0, jsx_runtime_1.jsx)("ul", { children: asns.map(asn => ((0, jsx_runtime_1.jsx)(result_item_1.UniversalSearchResultsItem, Object.assign({}, asn, { isAccountLogoVisible: isMasonhubUser(userType) }), asn.id))) })) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "universal-search-empty" }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { i18nKey: "common:noAsnsFound" }) }))) }))), isVisible("orders") && ((0, jsx_runtime_1.jsx)(UniversalSearchResultsType, Object.assign({ typeKey: "orders", count: orders.length, dotColor: "#7F77DD" }, { children: orders.length > 0 ? ((0, jsx_runtime_1.jsx)("ul", { children: orders.map(order => ((0, jsx_runtime_1.jsx)(result_item_1.UniversalSearchResultsItem, Object.assign({}, order, { isAccountLogoVisible: isMasonhubUser(userType) }), order.id))) })) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "universal-search-empty" }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { i18nKey: "common:noOrdersFound" }) }))) }))), isVisible("rmas") && ((0, jsx_runtime_1.jsx)(UniversalSearchResultsType, Object.assign({ typeKey: "rmas", count: rmas.length, dotColor: "#D85A30" }, { children: rmas.length > 0 ? ((0, jsx_runtime_1.jsx)("ul", { children: rmas.map(rma => ((0, jsx_runtime_1.jsx)(result_item_1.UniversalSearchResultsItem, Object.assign({}, rma, { isAccountLogoVisible: isMasonhubUser(userType) }), rma.id))) })) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "universal-search-empty" }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { i18nKey: "common:noRmasFound" }) }))) })))] })) })));
};
exports.UniversalSearchResults = UniversalSearchResults;
const UniversalSearchResultsType = ({ typeKey, count, dotColor, children, }) => {
    const [isCollapsed, setIsCollapsed] = (0, react_2.useState)(false);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: universalSearchResultsTypeStyles, className: "universal-search-type-section" }, { children: [(0, jsx_runtime_1.jsxs)("button", Object.assign({ className: "universal-search-type-head", onClick: () => setIsCollapsed(c => !c), "aria-expanded": !isCollapsed }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "type-label" }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { i18nKey: `common:${typeKey}` }) })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "type-count" }, { children: count })), (0, jsx_runtime_1.jsx)("svg", Object.assign({ className: (0, clsx_1.default)("type-chevron", { collapsed: isCollapsed }), width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M9 18l6-6-6-6" }) }))] })), !isCollapsed && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "type-body" }, { children: children }))] })));
};
const UniversalSearchResultsStyles = (0, react_1.css) `
  top: 0;
  left: 0;
  right: 0;
  position: absolute;
  z-index: 99;
  cursor: default;

  @media (max-width: ${breakpoints_1.MOBILE_MAX_LANDSCAPE_WIDTH}px) {
    top: ${container_1.UNIVERSAL_SEARCH_MAX_HEIGHT}px;
    bottom: 0;
    position: fixed;
  }

  > div {
    overflow: auto;
    max-width: 100%;
    max-height: calc(100vh - 100px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 8px 8px;
    border: 0.5px solid rgba(0,0,0,0.08);
  }

  .universal-search-filter-tabs {
    display: flex;
    overflow-x: auto;
    border-bottom: 1px solid rgba(0,0,0,0.07);
    padding: 0 8px;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
  }

  .universal-search-filter-tab {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px 10px;
    font-size: 12px;
    font-weight: 500;
    color: rgba(0,0,0,0.45);
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    white-space: nowrap;
    transition: color 120ms, border-color 120ms;

    &:hover { color: rgba(0,0,0,0.7); }
    &.active { color: var(--primary-color); border-bottom-color: var(--primary-color); }
    &.active .tab-count { background: color-mix(in srgb, var(--primary-color) 12%, transparent); color: var(--primary-color); }

    .tab-count {
      font-size: 11px;
      padding: 1px 6px;
      border-radius: 8px;
      background: rgba(0,0,0,0.05);
      color: rgba(0,0,0,0.4);
      transition: background 120ms, color 120ms;
    }
  }

  .universal-search-empty {
    display: block;
    padding: 10px 12px;
    font-size: 12px;
    color: rgba(0,0,0,0.35);
  }
`;
const universalSearchResultsTypeStyles = (0, react_1.css) `
  border-bottom: 0.5px solid rgba(0,0,0,0.07);
  &:last-child { border-bottom: none; }

  .universal-search-type-head {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: rgba(0,0,0,0.02);
    border: none;
    cursor: pointer;
    text-align: left;
    transition: background 100ms;

    &:hover { background: rgba(0,0,0,0.04); }
  }

  .type-label {
    flex: 1;
    font-size: 11px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: rgba(0,0,0,0.45);
  }

  .type-count {
    font-size: 11px;
    color: rgba(0,0,0,0.35);
  }

  .type-chevron {
    color: rgba(0,0,0,0.25);
    transition: transform 180ms ease;
    &.collapsed { transform: rotate(-90deg); }
  }

  .type-body {
    padding: 2px 0;
  }
`;
